/* eslint-disable no-plusplus */
import { subYears, getYear, format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function getEveryMonth() {
  const months = [];
  let i;

  for (i = 0; i < 12; i++) {
    months.push(ptBR.localize.month(i));
  }

  return months;
}

export function getYearsInterval(interval) {
  const years = [];
  let i;

  for (i = interval; i >= 0; i--) {
    years.push(getYear(subYears(new Date(), i)));
  }

  return years.sort((a, b) => b - a);
}

export function firstAndLastDayOfTheMonth(year, month, output = 'yyyy-MM-dd') {
  return {
    first: format(new Date(year, Number(month - 1), 1), output),
    last: format(new Date(year, month, 0), output),
  };
}
